import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges  } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { UserService } from 'src/app/services/user.service';

interface modelosVersiones{
  value: string;
  viewValue: string;
}
interface Estados{
  value: number;
  name: string;
}
interface Establecimientos{
  value: number;
  name: string;
}
interface Clientes{
  value: number;
  name: string;
}
@Component({
  selector: 'app-agregar-dispositivo',
  templateUrl: './agregar-dispositivo.component.html',
  styleUrls: ['./agregar-dispositivo.component.css'],
})
export class AgregarDispositivoComponent implements OnDestroy{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 14;
  addressData: any;

  etiqueta: string = "";
  descripcion: string = "";
  nSerie: string = "";
  nSIM: string = "";
  searchPlace: string = "";
  file: File | undefined
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  disabledCheckbox = false;
  checkedT1 = false;
  checkedT2 = false;
  checkedT3 = false;
  checkedT4 = false;
  valorTanque1: string = '';
  valorTanque2: string = '';
  valorTanque3: string = '';
  valorTanque4: string = '';
  showEstablecimientoError: boolean = false;
  showClienteError: boolean = false;
  dispositivoCreado: boolean = false;
  establishmentData: any = []; //Información de los establecimientos
  clientsData: any = []; //Información de los clientes
  errorMessage : string =""; //Mensaje de error
  tiempoEsperaRecarga: number = 60000; //Despues del error 429 se esperan 60 segundos para recargar la página
  version: number | undefined;
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;
  configuracionFinalizada: boolean = false;
  map: any; 
  marker: any;

  modeloVersion: modelosVersiones[] = [
    {value: 'noImplementado-0', viewValue: 'Sin Implementar'}
  ];
  selectedVersion: string = "";

  //estadoControl = new FormControl<Estados | null>(null, Validators.required);
  estado: Estados[] = [
    {value: 0, name: 'Desactivado'},
    {value: 1, name: 'Activado'}
  ];
  selectedEstado: number =  1;

  //Clientes
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  //Establecimientos
  establecimientos: Establecimientos[] = [];
  //selectedEstablecimiento: number | undefined;

  //AUTOCOMPLETE
  myControl = new FormControl<string | Establecimientos>('');
  filteredOptions!: Observable<Establecimientos[]>;

  //Subscripciones
  private establishmentSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private agregarDispositivoSubscription: Subscription | undefined;

  @Input() userId: any;

  constructor(private userService: UserService ,private deviceService: DeviceService, private router: Router, 
    private error429: Error429Service, private mapService: MapService, private cdr: ChangeDetectorRef){}

  ngAfterViewInit(): void {
    //Conseguir datos de clientes
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientsData.push(resp[i]);
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        console.log(this.clientsData);
        console.log(this.clientes);
      }
    });
    //Datos de los establecimientos
    this.establishmentSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.establishmentData.push(resp[i]);
          this.establecimientos.push({
            value: resp[i].id,
            name: resp[i].est_name
          });
        }
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const name = typeof value === 'string' ? value : value?.name;
            return name ? this._filter(name as string) : this.establecimientos.slice();
          }),
        );
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.mapService.loadMapScript(this.initMap.bind(this));
      }
    })
  }

  //AUTOCOMPLETE
    private _filter(name: string): Establecimientos[] {
      const filterValue = name.toLowerCase();

      return this.establecimientos.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    displayFn(establecimiento: Establecimientos): string {
      return establecimiento && establecimiento.name ? establecimiento.name : '';
    }

    limpiarSeleccion(): void {
      this.myControl.setValue('');
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value?.name;
          return name ? this._filter(name as string) : this.establecimientos.slice();
        }),
      );
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
      const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
      console.log(selectedDispositivo);
      if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
        this.showEstablecimientoError = false;
        for(let i = 0; i<this.establishmentData.length; i++){
          if(this.establishmentData[i].id == selectedDispositivo.value){
            console.log(this.establishmentData[i]);
            this.lat = this.establishmentData[i].est_lat;
            this.lng = this.establishmentData[i].est_lng;
            this.getAddress(this.lat, this.lng);
            this.marker.setPosition({ lat: this.lat, lng: this.lng });
            this.map.setCenter({ lat: this.lat, lng: this.lng });
          }
        }
      } else {
        this.showEstablecimientoError = true;
      }
    }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.agregarDispositivoSubscription) {
      this.agregarDispositivoSubscription.unsubscribe();
    } 
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        this.cdr.detectChanges();
      } else{
        console.log("No hay resultados");
      }
    })
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
    if (this.file && this.file.type === 'image/jpeg') {
      this.previewImage();
      //console.log('Archivo seleccionado:', this.file.name);
      this.showImageErrorMessage = false;
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
      console.log('Por favor, seleccione un archivo .jpg');
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  previewImage() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result;
    };
    reader.readAsDataURL(this.file as Blob);
  }

  updateEstadoErrorCliente() {
    if (this.selectedCliente == undefined) {
        this.showClienteError = true;
    } else {
        this.showClienteError = false;
    }
  }

  /*updateEstadoErrorEstablecimiento() {
    if (this.selectedEstablecimiento == undefined) {
        this.showEstablecimientoError = true;
    } else {
        this.showEstablecimientoError = false;
        for(let i = 0; i<this.establishmentData.length; i++){
          if(this.establishmentData[i].id==this.selectedEstablecimiento){
            console.log(this.establishmentData[i]);
            this.lat = this.establishmentData[i].est_lat;
            this.lng = this.establishmentData[i].est_lng;
            this.getAddress(this.lat, this.lng);
            this.marker.setPosition({ lat: this.lat, lng: this.lng });
            this.map.setCenter({ lat: this.lat, lng: this.lng });
          }
        }
    }
  }*/

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para devolver 1 si el valor es true y 0 si es false
  booleanToNumber(value: boolean): number {
    return value ? 1 : 0;
  }

  guardarDispositivo() {
    //Comprobar si falta por seleccionar el cliente
    if (this.selectedCliente === undefined) {
      this.showClienteError = true;
    } else {
      this.showClienteError = false;
    }
    //Comprobar si falta por seleccionar establecimiento
    //Autocomplete
    const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      //El dispositivo ha sido elegido
      this.showEstablecimientoError = false;
    } else {
      this.showEstablecimientoError = true;
    }

    if(this.showEstablecimientoError == false && this.showClienteError == false && selectedDispositivo && typeof selectedDispositivo !== 'string'){

      let configuracionFinalizada;
      if (this.configuracionFinalizada == false){
        configuracionFinalizada = 0;
      } else {
        configuracionFinalizada = 1;
      }

      let dispositivo = {
        _method: "PUT", 
        label: this.etiqueta, 
        description: this.descripcion, 
        serie: this.nSerie,
        sim: this.nSIM, 
        version_id: this.version,
        cliente_id: this.selectedCliente, 
        establishment_id: selectedDispositivo.value.toString() || '', 
        /*multitanque: this.disabledCheckbox,
        t1: this.booleanToNumber(this.checkedT1), 
        t2: this.booleanToNumber(this.checkedT2),
        t3: this.booleanToNumber(this.checkedT3), 
        t4: this.booleanToNumber(this.checkedT4), 
        cap1: this.valorTanque1,
        cap2: this.valorTanque2, 
        cap3: this.valorTanque3, 
        cap4: this.valorTanque4,*/
        locked: configuracionFinalizada,
        status: this.selectedEstado
      };

      this.agregarDispositivoSubscription = this.deviceService.createDevice(dispositivo).subscribe({
        next:resp => {
          console.log(resp);
        }, error: err =>{
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.dispositivoCreado=true;
            setTimeout(() => {
              this.lat = 43.0081016;
              this.lng = -7.5561412;
              this.getAddress(this.lat, this.lng);
              this.etiqueta = "";
              this.descripcion = "";
              this.nSerie = "";
              this.nSIM = "";
              this.version = undefined;
              this.selectedCliente = undefined;
              this.limpiarSeleccion();
              this.disabledCheckbox = false;
              this.checkedT1 = false;
              this.checkedT2 = false;
              this.checkedT3 = false;
              this.checkedT4 = false;
              this.valorTanque1 = '';
              this.valorTanque2 = '';
              this.valorTanque3 = '';
              this.valorTanque4 = '';
              this.selectedEstado = 1;
              this.waitAfterSave = false;
              this.dispositivoCreado = false;
            }, 3500);
          }
        }
      });
    }

    let configuracionFinalizada;
    if (this.configuracionFinalizada == false){
      configuracionFinalizada = 0;
    } else {
      configuracionFinalizada = 1;
    }
    console.log(configuracionFinalizada);

    console.log('Valor de etiqueta:', this.etiqueta);
    console.log('Valor de descripcion:', this.descripcion);
    console.log('Configuración finalizada:', this.configuracionFinalizada);
    console.log('Cliente seleccionado: ', this.selectedCliente);
    console.log('Imagen:', this.file);
    console.log('Valor de Nº de serie:', this.nSerie);
    console.log('Valor de Nº de SIM:', this.nSIM);
    console.log('Versión del dispositivo: ', this.version);

    console.log('Multitanque: ',this.disabledCheckbox);
    console.log('Tanque 1: ',this.checkedT1);
    console.log('Capacidad Tanque 1 = '+ this.valorTanque1);
    console.log('Tanque 2: ',this.checkedT2);
    console.log('Capacidad Tanque 2 = '+ this.valorTanque2);
    console.log('Tanque 3: ',this.checkedT3);
    console.log('Capacidad Tanque 3 = '+ this.valorTanque3);
    console.log('Tanque 4: ',this.checkedT4);
    console.log('Capacidad Tanque 4 = '+ this.valorTanque4);

    console.log('Estado: ', this.selectedEstado);

    console.log("--------------------------------");
  }

}
